module.exports = __webpack_public_path__ + "img/if_map-marker_3688470.7dd70d71.png";